import React, { FC } from "react";
import { theme } from "../../../config";
import { Button } from "../../atoms/Button";
import { BodyWrapper, ModalButtonsWrapper } from "./elements";

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  disableConfirm?: boolean;
};

const ApplicantDetailsModalFooter: FC<Props> = ({
  onCancel,
  onConfirm,
  disableConfirm,
}) => {
  return (
    <BodyWrapper>
      <p>
        By clicking “
        <span style={{ color: theme.colors.secondary }}>Confirm</span>” you
        agree to move this applicant’s status
      </p>
      <ModalButtonsWrapper>
        <Button type="primary" id="cancel_btn" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={disableConfirm} type="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </ModalButtonsWrapper>
    </BodyWrapper>
  );
};

export default ApplicantDetailsModalFooter;
